// extracted by mini-css-extract-plugin
export var button = "_o8-2";
export var card = "_o8-0";
export var closeButtonContainer = "_o8-3";
export var iconContainer = "_o8-1";